module.exports = __webpack_public_path__ + "media/mypage/images/menu/spm3-6abf8bb9ec66b3bfa20b8df1139cf875.png";